module.exports = "<!DOCTYPE html> <html> <head> <meta charset=UTF-8> <meta name=viewport content=\"width=device-width,initial-scale=1\"> <title>Elcon Megarad Landing</title> <link rel=stylesheet href=https://maxcdn.bootstrapcdn.com/font-awesome/4.6.2/css/font-awesome.min.css> <link href=\"https://fonts.googleapis.com/css?family=Raleway:100,200,900\" rel=stylesheet type=text/css> <script src=https://use.typekit.net/kwo5htm.js></script> <script>try{Typekit.load({async:!0})}catch(e){}</script> </head> <body> <div id=root></div> </body> </html>";


/*****************
 ** WEBPACK FOOTER
 ** ./web/index.html
 ** module id = 1
 ** module chunks = 0
 **/